// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ManageReservation-panelHeader-fkrQi {
    border-radius: 12px;
    width: 100%;
    display: block;
    border: 1px solid var(--primary-border);
    background: var(--primary-white-bg);
    padding: 15px 24px 48px 24px;
}


.ManageReservation-filterBtn-u1jis {
    width: -webkit-max-content;
    width: -moz-max-content;
    width: max-content;
    max-width: 100%;
    white-space: normal;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    word-break: break-word;
    border-radius: 6px;
    background-color: transparent !important;
    border: 1px solid var(--primary-border) !important;
    padding: 10px 19px !important;
    color: var(--common-text-color) !important;
    -webkit-box-shadow: inherit !important;
            box-shadow: inherit !important;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
}


.ManageReservation-linkCssActive-jea5v {
    background-color: var(--btn-primary-bg) !important;
    border: 1px solid var(--btn-primary-bg) !important;
    color: var(--btn-primary-color) !important;
    padding: 10px 19px !important;
    border-radius: 6px !important;
    -webkit-box-shadow: inherit !important;
            box-shadow: inherit !important;
}


.ManageReservation-linkCssActive-jea5v img {
    -webkit-filter: invert(89%) sepia(100%) saturate(27%) hue-rotate(8deg) brightness(109%) contrast(107%);
            filter: invert(89%) sepia(100%) saturate(27%) hue-rotate(8deg) brightness(109%) contrast(107%);
}


.ManageReservation-plusIcon-RmLcL {
    margin-right: 6px;
    width: 16px;
    height: 15px;
    -o-object-fit: contain;
       object-fit: contain;
}


.ManageReservation-noMargin-yeJp_ {
    margin: 0;
}


.ManageReservation-searchFilterGrid-jMBPj {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 20px;
}


@media screen and (max-width: 767px) {

    .ManageReservation-mobileSearchWidth-_7iYX {
        width: 100%;
    }

    .ManageReservation-linkCss-kHb9l {
        display: block;
        text-align: center;
    }

    .ManageReservation-searchFilterGrid-jMBPj {
        grid-template-columns: 1fr;
    }
}


@media screen and (min-width:768px) {
    .ManageReservation-filterBtnAlign-CGoMK {
        margin-left: auto;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ManageReservation/ManageReservation.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,WAAW;IACX,cAAc;IACd,uCAAuC;IACvC,mCAAmC;IACnC,4BAA4B;AAChC;;;AAGA;IACI,0BAAkB;IAAlB,uBAAkB;IAAlB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,kDAAkD;IAClD,6BAA6B;IAC7B,0CAA0C;IAC1C,sCAA8B;YAA9B,8BAA8B;IAC9B,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;;AAEA;IACI,kDAAkD;IAClD,kDAAkD;IAClD,0CAA0C;IAC1C,6BAA6B;IAC7B,6BAA6B;IAC7B,sCAA8B;YAA9B,8BAA8B;AAClC;;;AAEA;IACI,sGAA8F;YAA9F,8FAA8F;AAClG;;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;;AAEA;IACI,SAAS;AACb;;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;;AAEA;;IAEI;QACI,WAAW;IACf;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".panelHeader {\n    border-radius: 12px;\n    width: 100%;\n    display: block;\n    border: 1px solid var(--primary-border);\n    background: var(--primary-white-bg);\n    padding: 15px 24px 48px 24px;\n}\n\n\n.filterBtn {\n    width: max-content;\n    max-width: 100%;\n    white-space: normal;\n    display: flex;\n    align-items: center;\n    word-break: break-word;\n    border-radius: 6px;\n    background-color: transparent !important;\n    border: 1px solid var(--primary-border) !important;\n    padding: 10px 19px !important;\n    color: var(--common-text-color) !important;\n    box-shadow: inherit !important;\n    justify-content: center;\n}\n\n.linkCssActive {\n    background-color: var(--btn-primary-bg) !important;\n    border: 1px solid var(--btn-primary-bg) !important;\n    color: var(--btn-primary-color) !important;\n    padding: 10px 19px !important;\n    border-radius: 6px !important;\n    box-shadow: inherit !important;\n}\n\n.linkCssActive img {\n    filter: invert(89%) sepia(100%) saturate(27%) hue-rotate(8deg) brightness(109%) contrast(107%);\n}\n\n.plusIcon {\n    margin-right: 6px;\n    width: 16px;\n    height: 15px;\n    object-fit: contain;\n}\n\n.noMargin {\n    margin: 0;\n}\n\n.searchFilterGrid {\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    gap: 20px;\n}\n\n@media screen and (max-width: 767px) {\n\n    .mobileSearchWidth {\n        width: 100%;\n    }\n\n    .linkCss {\n        display: block;\n        text-align: center;\n    }\n\n    .searchFilterGrid {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media screen and (min-width:768px) {\n    .filterBtnAlign {\n        margin-left: auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panelHeader": `ManageReservation-panelHeader-fkrQi`,
	"filterBtn": `ManageReservation-filterBtn-u1jis`,
	"linkCssActive": `ManageReservation-linkCssActive-jea5v`,
	"plusIcon": `ManageReservation-plusIcon-RmLcL`,
	"noMargin": `ManageReservation-noMargin-yeJp_`,
	"searchFilterGrid": `ManageReservation-searchFilterGrid-jMBPj`,
	"mobileSearchWidth": `ManageReservation-mobileSearchWidth-_7iYX`,
	"linkCss": `ManageReservation-linkCss-kHb9l`,
	"filterBtnAlign": `ManageReservation-filterBtnAlign-CGoMK`
};
module.exports = ___CSS_LOADER_EXPORT___;
